import { Action, InlineLoader } from "@asurion-core/mx-asurion-ui-react";
import { Row, getActionState } from "@ubif/components";
import styled from "styled-components";

export const ShowMore = ({
  showMoreLabel,
  display,
  placeInCenter,
  isPending,
  onClick
}: {
  showMoreLabel: string;
  display: boolean;
  placeInCenter: boolean;
  isPending: boolean;
  onClick: () => void;
}) => {
  return display ? (
    <Row>
      <AlignCenterContainer placeInCenter={placeInCenter}>
        <Action
          size="sm"
          variant="flat"
          onClick={onClick}
          state={getActionState(isPending)}
          data-testid="show-more-button"
        >
          {showMoreLabel}
        </Action>
        {isPending ? <InlineLoader width="16px" title="Showing More" /> : null}
      </AlignCenterContainer>
    </Row>
  ) : null;
};

const AlignCenterContainer = styled.div<{ placeInCenter: boolean }>`
  width: 100%;
  ${(props) => props.placeInCenter && "display: flex; justify-content: center; gap:0.5rem"};
`;
